import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from 'clsx';
import Hidden from '@material-ui/core/Hidden'

import { Coin } from "../shared/component";
import useStyles from "../../styles/components/survey/stylesSurveyHolderDetail";

const createData = (name, dateline, status, rewardMedium, rewardSmall) => {
    return { name, dateline, status, rewardMedium, rewardSmall };
};

const SurveyMilestone = ({ milestones }) => {
    const rows = [];
    const classes = useStyles();

    if (milestones && !milestones.noreward) {
        milestones.bonusPoint.map((item, index) =>
            rows.push(
                createData(
                    `ECB ${index + 1}`,
                    milestones.dateMilestone[index],
                    milestones.missed[index] ?
                        milestones.getECB.length > 0 ?
                            milestones.getECB[index] ? "Achieved" : "Missed"
                            : "Missed"
                        : milestones.getECB.length > 0 ?
                            milestones.getECB[index] ? "Achieved" : "Missed"
                            : "On-going",
                    <Coin coin={milestones.bonusPoint[index]} size="medium" />,
                    <Coin coin={milestones.bonusPoint[index]} size="small" />
                )
            )
        );
    }

    return (
        <TableContainer component={Paper} classes={{ root: classes.rootTableContainer }}>
            <Table size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center" classes={{ root: classes.rootTableCell, head: classes.headTableCell }}>Milestone</TableCell>
                        <TableCell align="center" classes={{ root: classes.rootTableCell, head: classes.headTableCell }}>ECB Dateline</TableCell>
                        <TableCell align="center" classes={{ root: classes.rootTableCell, head: classes.headTableCell }}>Status</TableCell>
                        <TableCell align="center" classes={{ root: classes.rootTableCell, head: classes.headTableCell }}>Additional Coins</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.name}>
                            <TableCell align="center" component="th" scope="row" classes={{ root: classes.rootTableCell }}>
                                {row.name}
                            </TableCell>
                            <TableCell align="center" classes={{ root: classes.rootTableCell }}>{row.dateline}</TableCell>
                            <TableCell
                                align="center"
                                className={clsx(
                                    classes.rootTableCell,
                                    classes.rootTableCellStatus,
                                    row.status === 'Missed' && classes.rootTableCellStatusMissed
                                )}
                            >
                                {row.status}
                            </TableCell>
                            <TableCell
                                align="center"
                                classes={{ root: classes.rootTableCell }}
                                className={clsx(row.status === 'Missed' && classes.rootTableCellCoinMissed)}
                            >
                                <Hidden smDown>
                                    {row.rewardMedium}
                                </Hidden>
                                <Hidden mdUp>
                                    {row.rewardSmall}
                                </Hidden>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SurveyMilestone;